<template src="./index.html">
</template>

<script>
import {getdata} from './data.js'

export default {
  props: {
    autoApportionDiag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      headData: getdata().headData,
      tableData: [],
      suosqq: "",
      suosqz: "",
      companyNames: [{label: "test1", value: "test1"},{label: "test2", value: "test2"},{label: "test3", value: "test3"},{label: "test4", value: "test4"},{label: "test5", value: "test5"},{label: "test6", value: "test6"}],
      checkCompanyNames: [],
    }
  },
  created() {
  },
  methods: {
    closediag() {
      this.$emit("closeAutoApportionDiag");
    },
    getApportionmentRatio() {
      this.$message.info("获取分摊比例：" + this.suosqq + "，" + this.suosqz + ";" + this.checkCompanyNames)
    },
    confirm() {
      this.$message.info("一键分摊确认");
      this.closediag();
    }
  }

}
</script>

<style>
</style>